enum FinalCustomerContractServiceType {
    Garantia = 5,
    LocacaoDeSoftware = 1,
    LocacaoDeSoftwareEHardware = 2,
    POC = 4,
    SuporteDeSoftware = 3
}

export default FinalCustomerContractServiceType;